import styled from "styled-components";

export const Container = styled.div`
  background: linear-gradient(180deg, #222831 0%, #1b1f26 55%, #15181e 100%);
  padding: 16px 12px 24px;
  min-height: 100vh;
  height: 100%;
  box-sizing: border-box;
  border-right: 1px solid rgba(255, 255, 255, 0.06);

  a {
    color: #f5f5f5;
  }

  .MuiListItem-root {
    border-radius: 10px;
    margin: 4px 0;
    padding: 10px 12px;
    transition: background 160ms ease, transform 160ms ease;
  }

  .MuiListItem-root:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translateX(2px);
  }

  .MuiListItem-root.Mui-selected {
    background: rgba(255, 255, 255, 0.18);
  }

  .MuiListItemIcon-root {
    min-width: 36px;
  }

  .MuiListItemText-primary {
    font-weight: 600;
    font-size: 14px;
  }
`;
export const Instagram = styled.p`
  color: #e0e0e0;
  padding: 12px 0 0;
  margin: 16px 0 0;
  text-align: center;
  font-size: 12px;
  line-height: 1.4;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  a {
    color: #fff;
  }
  img {
    margin-top: 6px;
    width: auto;
    max-width: 100%;
    height: auto;
    display: inline-block;
  }
`;
